import { ManagementPage } from "../components/common/ManagementPage";

const locationFields = [
  { name: "company_name", label: "Company name", required: true, placeholder: "Prairie Food Hub" },
  { name: "contact_name", label: "Contact name", placeholder: "Ops Desk" },
  { name: "phone", label: "Phone", placeholder: "403-555-1100" },
  { name: "address", label: "Address", required: true, placeholder: "2400 Barlow Trail" },
  { name: "city", label: "City", required: true, placeholder: "Calgary" },
  { name: "state_province", label: "Province / State", required: true, placeholder: "AB" },
  { name: "postal_code", label: "Postal code", placeholder: "T2E 7M4" },
  { name: "country", label: "Country", required: true, defaultValue: "Canada", placeholder: "Canada" },
  { name: "notes", label: "Notes", type: "textarea", placeholder: "Dock hours, reference details, access notes" },
];

export const LocationsPage = () => (
  <ManagementPage
    actionLabel="Add location"
    columns={[
      { key: "company_name", label: "Company" },
      { key: "address", label: "Address" },
      { key: "city", label: "City" },
      { key: "state_province", label: "Province / State" },
      { key: "country", label: "Country" },
    ]}
    description="Saved locations help repeat loads faster so dispatchers don’t need to retype the same stops every time."
    endpoint="/locations"
    entityName="Location"
    fields={locationFields}
    title="Locations"
  />
);